import { render, staticRenderFns } from "./DepotKeepsakesListComponent.vue?vue&type=template&id=6a4c5f02&"
import script from "./DepotKeepsakesListComponent.vue?vue&type=script&lang=ts&"
export * from "./DepotKeepsakesListComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
installComponents(component, {VDivider,VList,VListItemGroup})
